import { FC, ReactNode } from 'react';

interface Props {
    title: string | ReactNode;
    children: ReactNode;
    sectionClass?: string;
}

const InvestigationSection: FC<Props> = ({ title, children, sectionClass }) => {
    return (
        <div className={`grid grid-rows-[24px_calc(100%-30px)] bg-sf-gray-900 gap-4 p-4 rounded ${sectionClass ?? ''}`}>
            <div className="text-16 text-white font-medium flex-none">{title}</div>
            <div className="h-full w-full">{children}</div>
        </div>
    );
};

export default InvestigationSection;
